<script lang="ts">
  import { onMount } from "svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Navigation from "./Navigation.svelte"
  import { ChevronRight, ChevronLeft } from "lucide-svelte"
  import { onboardingStore } from "./onboarding.svelte"
  import { appStore } from "$app/store.svelte"

  import img from "@images/onboarding/goal_overview.jpg"

  let saving = false

  let errors: any = {}

  async function nextStep(): Promise<void> {
    saving = true
    errors = {}

    try {
      await xhr.post(`/plan_onboarding/${appStore.plan.id}/goal_overview.json`)

      window.location.href = `/plans/${appStore.plan.id}/goals`
    } catch (e) {
      if (e.response.data) {
        errors = e.response.data
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
      toast("There was an error saving your plan data", "error")
    } finally {
      saving = false
    }
  }

  onMount(() => {
    onboardingStore.setBrowserHistory({}, "goal_overview")
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full lg:w-1/2 xl:pr-16">
    <Navigation step="goal_overview" on:updateStep />

    <h2 class="mt-12 text-5xl font-bold text-left text-white">
      Goals Overview
    </h2>

    <p class="mt-8 text-white text-2xl max-w-xl">
      Great job making it this far! You are well on your way to getting your
      whole team focused and rowing in the same direction.
    </p>
    <p class="mt-8 text-white text-xl max-w-xl">
      The next step in your journey involves setting up your Goals. We organize
      goals in a hierarchy from Long-Term Goals to Annual Goals and then to
      Quarterly Goals. You can also create Tasks under your Quarterly Goals
      which help to create an action plan for accomplishing each goal.
    </p>

    <p class="mt-8 text-white text-xl max-w-xl">
      To get started with your goal setup the next step will take you to the
      Goals page within the Lead With Purpose platform and you will be guided
      through the creation of your first goal hierarchy.
    </p>

    <div class="space-y-8 mt-6 md:mt-8 max-w-xl">
      <div>
        <div class="flex items-center justify-between py-4 mt-6">
          <Button
            class="btn btn-rounded btn-big secondary flex items-center gap-1"
            processing={saving}
            onclick={() => {
              onboardingStore.prevStep()
            }}
          >
            <ChevronLeft class="text-gray-500 w-6 h-6" />
            <span class="font-light text-gray-500">PREVIOUS</span>
          </Button>
          <Button
            class="btn btn-rounded success btn-big flex items-center gap-1 text-core"
            processing={saving}
            onclick={nextStep}
          >
            <span class="font-light"> Go to my GOALS page </span>
            <ChevronRight class=" w-6 h-6" />
          </Button>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="relative w-full hidden lg:inline lg:absolute lg:inset-y-0 lg:-right-0 md:w-1/3 lg:w-1/2 lg:h-full bg-lwp-light-grey bg-center bg-no-repeat bg-cover"
  style="background-image: url({img})"
></div>
